import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import AppRoutes from "./routes/AppRoutes";
import Toaster from "./components/reusable-toaster/Toaster";
// import ScrollToTop from "./components/ScrollToTop";

const App: React.FC = () => {
  return (
    <div>
      <Toaster />
      <Router>
        {/* <ScrollToTop /> */}
        <AppRoutes />
      </Router>
    </div>
  );
};

export default App;
